import React from 'react';
import DeleteCartItem from './DeleteCartItem.component';
import PropTypes from 'prop-types';
import { EachCartItemContainer } from '../Course.styles';

const EachCartItem = ({ course, key, userId }) => {
  return (
    <EachCartItemContainer key={key}>
      <div>
        {/* Header for this to be course */}
        <h4>{course?.courseName}</h4>
        {/* This in italic underneath the course name */}
        {course.expiryDate === 0 ? (
          <span className="italicSpan">Course does not expire</span>
        ) : (
          <span className="italicSpan">
            Expires in {course?.expiryDate} years
          </span>
        )}
        <p>${course?.price}</p>
      </div>
      <DeleteCartItem courseId={course?.courseId} userId={userId} />
    </EachCartItemContainer>
  );
};
EachCartItem.propTypes = {
  key: PropTypes.string,
  course: PropTypes.shape({
    courseId: PropTypes.string,
    courseName: PropTypes.string,
    price: PropTypes.number,
    expiryDate: PropTypes.number,
  }),
  userId: PropTypes.string,
};

export default EachCartItem;
